import { render, staticRenderFns } from "./instructionCategory.vue?vue&type=template&id=3a9df29a"
import script from "./instructionCategory.vue?vue&type=script&lang=js"
export * from "./instructionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports